import makeStyles from '@mui/styles/makeStyles';

export const EXPANDED_MENU_WIDTH = 280;

export const useStyles = makeStyles(theme => ({
    disabled: {
        /* opacity: '15.9 !important',*/
        color: 'darkgray      !important',
        /*background: 'pink  !important', */
    },
    drawer: {
        overflow: 'visible',
        width: 0,
        transition: 'width 250ms ease',
        '> .MuiDrawer-paper': {
            overflow: 'auto',
        },
        '&.open': {
            width: EXPANDED_MENU_WIDTH,
        },
        '&.closed': {
            width: 80,
        },
        '& a': {
            color: 'currentColor',
            textDecoration: 'inherit',
        },
    },
    menuContainer: {
        overflow: 'auto',
        scrollbarColor: 'rgba(0, 0, 0, 0.5) rgba(0, 0, 0, 0.1)',
        '& .MuiPaper-root.MuiAccordion-root.Mui-expanded:before': {
            opacity: '1 !important'
        },
        '& .MuiPaper-root.MuiAccordion-root:last-child': {
            borderBottom: `1px solid ${theme.palette.divider} !important`
        },
    },

    navlist: {
        padding: '0 1rem 1rem 0 !important',
        '& ul': {
            width: '100%',
        }
    },
    accordionSummary: {
        background: theme.palette.background.paper,
        '&:hover': {
            borderLeft: '5px solid ' + theme.palette.primary.dark,
            paddingLeft: theme.spacing(1.375),
        },
    },
    mainNav: {
        flexGrow: 1,
        'overflowY': 'auto'
    },
    bottomRow: {
        position: 'sticky',
        bottom: 0,
    },
    searchbox: {
        margin: '0.5rem 1rem !important',
    },
    searchinput: {
        paddingLeft: theme.spacing(2),
        position: 'sticky',
        top: theme.spacing(6),
        zIndex: 1000,
        backgroundColor: theme.palette.background.paper
    },
    overflowSearch: {
        overflow: 'visible',
        width: 280,
    },

    menuList: {
        paddingTop: '0px',
        paddingBottom: '0px',
        overflow: 'auto',
        scrollbarWidth: 'thin',
    },

    menuItemText: {
        fontSize: 'small',
        color: 'gray'
    },

    menuItem: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        '&:hover, &:focus': {
            backgroundColor: 'light-gray',
            cursor: 'pointer'
        },
    },

    active: {
        backgroundColor: theme.palette.grey[200],
        display: 'Block',
    },
    activeMenuItem: {
        '&.active':{
            backgroundColor: theme.palette.grey[200],
        }
    },
    popper: {
        width: 275,
        placement: 'bottom',
        overflow: 'auto',
        scrollbarWidth: 'thin',
    }
}));
